// Fluxo real de uma guia UNIMED — a espinha das abas Guias e Lotes:
//   1 elegibilidade do cartão → 2 envio → 3 autorização → 4 realizado → 5 em lote → 6 lote enviado
// A etapa de cada guia é calculada no backend (auth-db.js, TISS_ETAPA_SQL).
import React from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

export const ETAPAS = [
  { n: 1, id: 'elegibilidade', label: 'Cartão' },
  { n: 2, id: 'enviada', label: 'Enviada' },
  { n: 3, id: 'autorizada', label: 'Autorizada' },
  { n: 4, id: 'realizada', label: 'Realizada' },
  { n: 5, id: 'em_lote', label: 'Em lote' },
  { n: 6, id: 'lote_enviado', label: 'Lote enviado' },
];
const ORDEM = { enviada: 2, autorizada: 3, realizada: 4, em_lote: 5, lote_enviado: 6 };

export const ETAPA_LABEL = {
  enviada: 'Aguardando autorização', autorizada: 'Autorizada — falta informar realizado',
  realizada: 'Realizada — falta entrar em lote', em_lote: 'Em lote — falta enviar o lote',
  lote_enviado: 'Lote enviado', problema: 'Erro ou negada', cancelada: 'Cancelada',
};

/** Seis segmentos: verde = etapa cumprida; vermelho = parou com problema. */
export function EtapaIndicador({ guia }) {
  const atual = ORDEM[guia.etapa] || (guia.etapa === 'problema' ? 2 : 0);
  const problema = guia.etapa === 'problema';
  const cancelada = guia.etapa === 'cancelada';
  const cor = (n) => {
    if (cancelada) return '#e0e0e0';
    if (n === 1) return guia.elegivel === false ? '#c62828' : guia.elegivel === true ? '#2e7d32' : '#cfd8dc';
    if (problema && n === atual) return '#c62828';
    return n <= atual ? '#2e7d32' : '#e0e0e0';
  };
  const titulo = ETAPAS.map(e => `${e.n}. ${e.label}${e.n === 1 ? (guia.elegivel === true ? ' ✓' : guia.elegivel === false ? ' ✗ (inelegível)' : ' (sem consulta)') : (e.n <= atual ? ' ✓' : '')}`).join('\n');
  return (
    <div title={titulo}>
      <div style={{ display: 'flex', gap: '2px', marginBottom: '3px' }}>
        {ETAPAS.map(e => <span key={e.n} style={{ width: '16px', height: '6px', borderRadius: '2px', background: cor(e.n) }} />)}
      </div>
      <div style={{ fontSize: '11px', color: problema ? '#c62828' : cancelada ? '#999' : '#555', fontWeight: 500 }}>
        {ETAPA_LABEL[guia.etapa] || guia.etapa}
      </div>
    </div>
  );
}

export function downloadXml(xml, filename) {
  const blob = new Blob([xml], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

/** A listagem não traz os XMLs (pesavam 25 KB por guia); busca a guia completa só na hora. */
export async function baixarXmlGuia(guiaId, toast) {
  try {
    const { data: g } = await axios.get(`${API_URL}/tiss/guias/${guiaId}`);
    const xmls = [['request', g.xml_request], ['response', g.xml_response], ['realizado', g.xml_realizado]].filter(x => x[1]);
    if (!xmls.length) return toast.warning('Nenhum XML disponível para esta guia');
    xmls.forEach(([suf, xml]) => downloadXml(xml, `tiss_guia_${g.numero_guia_prestador || g.id}_${suf}.xml`));
    if (xmls.length > 1) toast.info(`${xmls.length} XMLs baixados`);
  } catch { toast.error('Erro ao buscar XML da guia'); }
}

export async function baixarXmlLote(lote, toast) {
  try {
    const { data: l } = await axios.get(`${API_URL}/tiss/lotes/${lote.id}`);
    const xmls = [['request', l.xml_request], ['response', l.xml_response]].filter(x => x[1]);
    if (!xmls.length) return toast.warning('Nenhum XML disponível para este lote');
    xmls.forEach(([suf, xml]) => downloadXml(xml, `tiss_lote_${l.numero_lote || l.id}_${suf}.xml`));
    if (xmls.length > 1) toast.info(`${xmls.length} XMLs baixados`);
  } catch { toast.error('Erro ao buscar XML do lote'); }
}

export function abrirPdfGuia(guiaId) {
  const token = localStorage.getItem('token');
  window.open(`${API_URL}/tiss/guias/${guiaId}/pdf?token=${token}`, '_blank');
}

/** Paginação compacta: "1–50 de 312  ‹ 1/7 ›". */
export function Paginacao({ page, limit, total, onPage }) {
  const paginas = Math.max(1, Math.ceil(total / limit));
  const ini = total ? (page - 1) * limit + 1 : 0;
  const fim = Math.min(total, page * limit);
  const btn = { padding: '4px 10px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', background: '#fff', cursor: 'pointer' };
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 4px 0', fontSize: '12px', color: '#666' }}>
      <span>{ini}–{fim} de {total}</span>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <button style={btn} disabled={page <= 1} onClick={() => onPage(page - 1)}>‹</button>
        <span>{page} / {paginas}</span>
        <button style={btn} disabled={page >= paginas} onClick={() => onPage(page + 1)}>›</button>
      </div>
    </div>
  );
}
